import Vue from 'vue'

export default el => Promise.all([
  enqueueModule('text-input.vue'),
  enqueueModule('checkbox.vue')
]).then(() => new Vue({ el }))
